import * as z from 'zod'

export const FREE_PLAN = 'free' as const
export const STANDARD_PLAN = 'standard' as const
export const ENTERPRISE_PLAN = 'enterprise' as const
export const PAID_PLANS = [STANDARD_PLAN, ENTERPRISE_PLAN] as const
export const PLANS = [FREE_PLAN, ...PAID_PLANS] as const

export type PaidPlan = (typeof PAID_PLANS)[number]
export type Plan = (typeof PLANS)[number]

export const PaidPlanSchema = z.enum(PAID_PLANS)
export const PlanSchema = z.enum(PLANS)

/**
 * Default branch limits per plan type
 */
export const PLAN_BRANCH_LIMITS = {
  [FREE_PLAN]: 1,
  [STANDARD_PLAN]: 1,
  [ENTERPRISE_PLAN]: null, // null = unlimited
} as const
